import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {SectionBase} from '../../../components/section/section-base';
import {CalculationAgreementsSectionConfig} from './calculation-agreements-section.config';
import {AgreementsService} from '../../../services/agreements.service';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';
import {AgreementDestination} from '../../../../core/configuration/ui-config';
import {StepKey} from '../../../../core/enums/step-key.enum';
import {ConfigurationService} from '../../../../core/services/impl/configuration/configuration.service';
import {AgreementModel} from '../../../../core/models/agreement.model';
import {
  CheckboxesGroupComponent,
  CheckboxesGroupConfig
} from '../../../components/checkboxes-group/checkboxes-group.component';
import {Subscription} from 'rxjs/Rx';


@Component({
  selector: 'app-calculation-agreements-section',
  templateUrl: './calculation-agreements-section.component.html'
})
export class CalculationAgreementsSectionComponent extends SectionBase implements OnInit, OnDestroy {

  @ViewChild('checkboxesGroup') checkboxesGroup: CheckboxesGroupComponent;
  agreements: any[];
  readonlyAgreements: AgreementModel[];
  checkboxesGroupConfig: CheckboxesGroupConfig;
  checkboxesGroupFieldKeys: string[];
  subscriptions: Subscription[] = [];
  requiredFieldInfoVisible: boolean;
  readonly AGREEMENT_FIELD_KEY_PREFIX = 'CALCULATION';

  get agreementsVisible(): boolean {
    return this.checkboxesGroupConfig && this.agreements && this.agreements.length > 0;
  }

  constructor(public agreementsService: AgreementsService,
              private configuration: ConfigurationService) {
    super();
  }

  ngOnInit() {
    this.init();
    this.initBean();
    this.createConfig();
    this.buildForm();
    this.initControlsChanges();
    this.handleAgreementsUpdateFromDifferentSection();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
    this.subscriptions = [];
  }

  init(): void {
    if (this.agreementsService.agreementsCollectible) {
      this.initAgreements();
      this.updateCalculationAgreements();
      this.initCheckboxesGroup();
    }
  }

  createConfig(): void {
    const configBuilder = new CalculationAgreementsSectionConfig(this.agreementsService, this.AGREEMENT_FIELD_KEY_PREFIX);
    this.formConfig = configBuilder.createFormConfig(this.agreements);
  }

  initBean(): void {
    this.bean = {
      agreements: this.agreementsService.calculationAgreements
    };
  }

  initControlsChanges(): void {
    if (isNotNullOrUndefined(this.agreements)) {
      this.handleControlsState(...this.agreements.map(agreement => ({
        controlName: `${this.AGREEMENT_FIELD_KEY_PREFIX}_${agreement.code}`,
        behaviour: selected => this.agreementsService.changeAgreement(agreement.code, selected)
      })));
    }
  }

  private initAgreements(): void {
    if (isNotNullOrUndefined(this.configuration.uiConfig.agreementsConfig)) {
      const agreements = this.agreementsService.getAgreementsForDestination(StepKey.FIRST_STEP_0);
      this.agreements = agreements.filter(agreement => !agreement.details.readonly);
      this.readonlyAgreements = agreements.filter(agreement => agreement.details.readonly);
    } else {
      this.agreements = [];
      this.readonlyAgreements = [];
    }
    this.requiredFieldInfoVisible = this.agreements.some((agreement: AgreementModel) => agreement.details.required);
  }

  private updateCalculationAgreements(): void {
    const calculationAgreementsUndefined = !isNotNullOrUndefined(this.agreementsService.calculationAgreements) || this.agreementsService.calculationAgreements.length === 0;

    const agreementsFromConfig = this.agreementsService.getAgreementsForDestination(StepKey.FIRST_STEP_0);
    const calculationAgreementIncompatible = this.agreementsService.calculationAgreements
        .some(agreement => !isNotNullOrUndefined(agreementsFromConfig.find(item => item.code === agreement.code)));
    if (calculationAgreementsUndefined || calculationAgreementIncompatible) {
      this.agreementsService.calculationAgreements = this.agreements;
    }
  }

  private initCheckboxesGroup(): void {
    this.checkboxesGroupConfig = {
      checkAllLabel: 'SHARED.AGREEMENTS.checkAllAgreements'
    };
    this.checkboxesGroupFieldKeys = this.agreements.map(agreement => `${this.AGREEMENT_FIELD_KEY_PREFIX}_${agreement.code}`);
  }

  private handleAgreementsUpdateFromDifferentSection(): void {
    this.subscriptions.push(
        this.agreementsService.calculationAgreementSelectionUpdate$.subscribe(event => {
          const { code, selected } = event;
          this.getControl(`${this.AGREEMENT_FIELD_KEY_PREFIX}_${code}`).patchValue(selected, {emitEvent: false});
          if (isNotNullOrUndefined(this.checkboxesGroup)) {
            this.checkboxesGroup.updateAllChecked();
          }
        })
    );
  }

}
